import "./App.css";
import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./configuration/theme";
import { IPublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { LoginPage, Launcher } from "./pages";
import { ToastContainer } from "react-toastify";

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps): JSX.Element {
  return (
    <MsalProvider instance={pca}>
      <Pages />
    </MsalProvider>
  );
}

const Pages: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Launcher />} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      </HashRouter>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </ThemeProvider>
  );
};

export default App;
